import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import './FilterPill.scss'

const FilterPill = props => {
  const pillClass = classNames('FilterPill', {
    'FilterPill--active': props.active
  })

  return (
    <div
      className={pillClass}
      onClick={() => {
        props.handleClick(props.filterValue || props.label)
      }}
    >
      {props.label}
    </div>
  )
}

FilterPill.propTypes = {
  active: PropTypes.bool,
  label: PropTypes.string,
  filterValue: PropTypes.string,
  handleClick: PropTypes.func
}

export default FilterPill
